import { Button } from '@/components/Button/styles';
import { Wrapper } from '@/styles/pages/404';
import { useRouter } from 'next/router';

const NotFound: React.FC = () => {
  const router = useRouter();

  return (
    <Wrapper>
      <h1>
        Hmm, não consigo ver muito bem mas parece que essa página não existe,
        tem certeza que era isso que estava procurando?
      </h1>
      <Button
        onClick={() => {
          router.push('/');
        }}
      >
        Voltar para home
      </Button>
    </Wrapper>
  );
};

export default NotFound;
